var cov_2oyp5jgfy3 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/More.tsx",
      hash = "4ab9363d484479604ef64ef21991eb09f24e3bcc",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/More.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 52
        }
      },
      "1": {
        start: {
          line: 13,
          column: 43
        },
        end: {
          line: 13,
          column: 52
        }
      },
      "2": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 14,
          column: 32
        }
      },
      "3": {
        start: {
          line: 15,
          column: 16
        },
        end: {
          line: 15,
          column: 43
        }
      },
      "4": {
        start: {
          line: 16,
          column: 26
        },
        end: {
          line: 16,
          column: 35
        }
      },
      "5": {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 17,
          column: 56
        }
      },
      "6": {
        start: {
          line: 18,
          column: 23
        },
        end: {
          line: 18,
          column: 58
        }
      },
      "7": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 19,
          column: 42
        }
      },
      "8": {
        start: {
          line: 20,
          column: 23
        },
        end: {
          line: 20,
          column: 84
        }
      },
      "9": {
        start: {
          line: 22,
          column: 17
        },
        end: {
          line: 22,
          column: 43
        }
      },
      "10": {
        start: {
          line: 23,
          column: 22
        },
        end: {
          line: 23,
          column: 46
        }
      },
      "11": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 103
        }
      },
      "12": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 13
        }
      },
      "13": {
        start: {
          line: 27,
          column: 17
        },
        end: {
          line: 27,
          column: 18
        }
      },
      "14": {
        start: {
          line: 28,
          column: 23
        },
        end: {
          line: 33,
          column: 4
        }
      },
      "15": {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 29,
          column: 44
        }
      },
      "16": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 117
        }
      },
      "17": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 23
        }
      },
      "18": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 18
        }
      },
      "19": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "20": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 12
        }
      },
      "21": {
        start: {
          line: 37,
          column: 14
        },
        end: {
          line: 37,
          column: 15
        }
      },
      "22": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "23": {
        start: {
          line: 39,
          column: 22
        },
        end: {
          line: 39,
          column: 37
        }
      },
      "24": {
        start: {
          line: 41,
          column: 23
        },
        end: {
          line: 41,
          column: 43
        }
      },
      "25": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 50,
          column: 7
        }
      },
      "26": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 21
        }
      },
      "27": {
        start: {
          line: 46,
          column: 22
        },
        end: {
          line: 46,
          column: 36
        }
      },
      "28": {
        start: {
          line: 47,
          column: 9
        },
        end: {
          line: 47,
          column: 64
        }
      },
      "29": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 51
        }
      },
      "30": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 20
        }
      },
      "31": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 55,
          column: 7
        }
      },
      "32": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 13
        }
      },
      "33": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 14
        }
      },
      "34": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 60,
          column: 7
        }
      },
      "35": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 16
        }
      },
      "36": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 66,
          column: 3
        }
      },
      "37": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 11
        }
      },
      "38": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 67,
          column: 12
        }
      },
      "39": {
        start: {
          line: 74,
          column: 21
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "40": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 16
        }
      },
      "41": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "42": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 52
        }
      },
      "43": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 29
        }
      },
      "44": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 18
        }
      },
      "45": {
        start: {
          line: 106,
          column: 23
        },
        end: {
          line: 106,
          column: 33
        }
      },
      "46": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 126,
          column: 7
        }
      },
      "47": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 126,
          column: 7
        }
      },
      "48": {
        start: {
          line: 128,
          column: 19
        },
        end: {
          line: 128,
          column: 88
        }
      },
      "49": {
        start: {
          line: 128,
          column: 76
        },
        end: {
          line: 128,
          column: 87
        }
      },
      "50": {
        start: {
          line: 129,
          column: 18
        },
        end: {
          line: 129,
          column: 113
        }
      },
      "51": {
        start: {
          line: 129,
          column: 90
        },
        end: {
          line: 129,
          column: 112
        }
      },
      "52": {
        start: {
          line: 130,
          column: 24
        },
        end: {
          line: 130,
          column: 36
        }
      },
      "53": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 151,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "getResetMore",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 28
          }
        },
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 33
          },
          end: {
            line: 28,
            column: 34
          }
        },
        loc: {
          start: {
            line: 28,
            column: 41
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 81,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        loc: {
          start: {
            line: 81,
            column: 32
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 81
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 32
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 90
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 11
          },
          end: {
            line: 152,
            column: 3
          }
        },
        line: 94
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 128,
            column: 58
          },
          end: {
            line: 128,
            column: 59
          }
        },
        loc: {
          start: {
            line: 128,
            column: 76
          },
          end: {
            line: 128,
            column: 87
          }
        },
        line: 128
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 129,
            column: 72
          },
          end: {
            line: 129,
            column: 73
          }
        },
        loc: {
          start: {
            line: 129,
            column: 90
          },
          end: {
            line: 129,
            column: 112
          }
        },
        line: 129
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 52
          }
        }, {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 52
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 13,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 13,
            column: 16
          }
        }, {
          start: {
            line: 13,
            column: 20
          },
          end: {
            line: 13,
            column: 25
          }
        }, {
          start: {
            line: 13,
            column: 29
          },
          end: {
            line: 13,
            column: 41
          }
        }],
        line: 13
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 19,
            column: 36
          },
          end: {
            line: 19,
            column: 38
          }
        }, {
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 19,
            column: 42
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        }, {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        }],
        line: 34
      },
      "4": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        }],
        line: 43
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        }, {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }, {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }],
        line: 57
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        }, {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        }],
        line: 64
      },
      "8": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 15
          }
        }, {
          start: {
            line: 64,
            column: 19
          },
          end: {
            line: 64,
            column: 34
          }
        }],
        line: 64
      },
      "9": {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 126,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 126,
            column: 7
          }
        }, {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 126,
            column: 7
          }
        }],
        line: 107
      },
      "10": {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 20
          }
        }, {
          start: {
            line: 107,
            column: 24
          },
          end: {
            line: 107,
            column: 47
          }
        }],
        line: 107
      },
      "11": {
        loc: {
          start: {
            line: 135,
            column: 69
          },
          end: {
            line: 135,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 135,
            column: 69
          },
          end: {
            line: 135,
            column: 72
          }
        }, {
          start: {
            line: 135,
            column: 76
          },
          end: {
            line: 135,
            column: 82
          }
        }, {
          start: {
            line: 135,
            column: 86
          },
          end: {
            line: 135,
            column: 102
          }
        }],
        line: 135
      },
      "12": {
        loc: {
          start: {
            line: 145,
            column: 15
          },
          end: {
            line: 145,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 44
          },
          end: {
            line: 145,
            column: 48
          }
        }, {
          start: {
            line: 145,
            column: 51
          },
          end: {
            line: 145,
            column: 57
          }
        }],
        line: 145
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/More.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import classnames from 'classnames';
import { parsePxToNumber } from '../utils/dom/element';
import Popover from '../Popover';
// if num = -1 display all else display num
export function getResetMore(onFilter, container, doms) {
  cov_2oyp5jgfy3.f[0]++;
  cov_2oyp5jgfy3.s[0]++;

  if ((cov_2oyp5jgfy3.b[1][0]++, !container) || (cov_2oyp5jgfy3.b[1][1]++, !doms) || (cov_2oyp5jgfy3.b[1][2]++, !doms.length)) {
    cov_2oyp5jgfy3.b[0][0]++;
    cov_2oyp5jgfy3.s[1]++;
    return -1;
  } else {
    cov_2oyp5jgfy3.b[0][1]++;
  }

  var items = (cov_2oyp5jgfy3.s[2]++, Array.from(doms));
  var style = (cov_2oyp5jgfy3.s[3]++, getComputedStyle(container));

  var _ref = (cov_2oyp5jgfy3.s[4]++, container),
      clientWidth = _ref.clientWidth;

  var paddingLeft = (cov_2oyp5jgfy3.s[5]++, parsePxToNumber(style.paddingLeft));
  var paddingRight = (cov_2oyp5jgfy3.s[6]++, parsePxToNumber(style.paddingRight));
  var minFilterWidth = (cov_2oyp5jgfy3.s[7]++, onFilter ? (cov_2oyp5jgfy3.b[2][0]++, 16) : (cov_2oyp5jgfy3.b[2][1]++, 0));
  var contentWidth = (cov_2oyp5jgfy3.s[8]++, clientWidth - paddingLeft - paddingRight - minFilterWidth - 1);
  var hideEl = (cov_2oyp5jgfy3.s[9]++, items.pop());
  var hideElStyle = (cov_2oyp5jgfy3.s[10]++, getComputedStyle(hideEl));
  var hideMargin = (cov_2oyp5jgfy3.s[11]++, parsePxToNumber(hideElStyle.marginLeft) + parsePxToNumber(hideElStyle.marginRight));
  var num = (cov_2oyp5jgfy3.s[12]++, 0);
  var sumWidth = (cov_2oyp5jgfy3.s[13]++, 0);
  var itemWidthArr = (cov_2oyp5jgfy3.s[14]++, items.map(function (item) {
    cov_2oyp5jgfy3.f[1]++;
    var itemStyle = (cov_2oyp5jgfy3.s[15]++, getComputedStyle(item));
    var itemLen = (cov_2oyp5jgfy3.s[16]++, item.offsetWidth + parsePxToNumber(itemStyle.marginLeft) + parsePxToNumber(itemStyle.marginRight));
    cov_2oyp5jgfy3.s[17]++;
    sumWidth += itemLen;
    cov_2oyp5jgfy3.s[18]++;
    return itemLen;
  }));
  cov_2oyp5jgfy3.s[19]++;

  if (sumWidth <= contentWidth) {
    cov_2oyp5jgfy3.b[3][0]++;
    cov_2oyp5jgfy3.s[20]++;
    num = -1;
  } else {
    cov_2oyp5jgfy3.b[3][1]++;
    var len = (cov_2oyp5jgfy3.s[21]++, 0);
    cov_2oyp5jgfy3.s[22]++;

    for (var i = 0; i < itemWidthArr.length; i++) {
      var itemLen = (cov_2oyp5jgfy3.s[23]++, itemWidthArr[i]); // number length

      var resetNum = (cov_2oyp5jgfy3.s[24]++, items.length - 1 - i);
      var moreWidth = void 0;
      cov_2oyp5jgfy3.s[25]++;

      if (resetNum <= 0) {
        cov_2oyp5jgfy3.b[4][0]++;
        cov_2oyp5jgfy3.s[26]++;
        moreWidth = 0;
      } else {
        cov_2oyp5jgfy3.b[4][1]++;
        var reset = (cov_2oyp5jgfy3.s[27]++, "+".concat(resetNum));
        cov_2oyp5jgfy3.s[28]++;
        hideEl.childNodes[0].innerText = reset; // (+num) width

        cov_2oyp5jgfy3.s[29]++;
        moreWidth = hideEl.offsetWidth + hideMargin;
      }

      cov_2oyp5jgfy3.s[30]++;
      len += itemLen;
      cov_2oyp5jgfy3.s[31]++;

      if (len > contentWidth - moreWidth) {
        cov_2oyp5jgfy3.b[5][0]++;
        cov_2oyp5jgfy3.s[32]++;
        break;
      } else {
        cov_2oyp5jgfy3.b[5][1]++;
      }

      cov_2oyp5jgfy3.s[33]++;
      num += 1;
      cov_2oyp5jgfy3.s[34]++;

      if (i === items.length - 1) {
        cov_2oyp5jgfy3.b[6][0]++;
        cov_2oyp5jgfy3.s[35]++;
        // not show more
        num = -1;
      } else {
        cov_2oyp5jgfy3.b[6][1]++;
      }
    }
  } // at least show one


  cov_2oyp5jgfy3.s[36]++;

  if ((cov_2oyp5jgfy3.b[8][0]++, num === 0) && (cov_2oyp5jgfy3.b[8][1]++, itemWidthArr[0])) {
    cov_2oyp5jgfy3.b[7][0]++;
    cov_2oyp5jgfy3.s[37]++;
    num = 1;
  } else {
    cov_2oyp5jgfy3.b[7][1]++;
  }

  cov_2oyp5jgfy3.s[38]++;
  return num;
}
var DefaultValue = (cov_2oyp5jgfy3.s[39]++, {
  trigger: 'hover'
});

var More =
/*#__PURE__*/
function (_Component) {
  _inherits(More, _Component);

  var _super = _createSuper2(More);

  function More(props) {
    var _this;

    _classCallCheck(this, More);

    cov_2oyp5jgfy3.f[2]++;
    cov_2oyp5jgfy3.s[40]++;
    _this = _super.call(this, props);
    cov_2oyp5jgfy3.s[41]++;
    _this.state = {
      status: false
    };
    cov_2oyp5jgfy3.s[42]++;
    _this.changeStatus = _this.changeStatus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(More, [{
    key: "changeStatus",
    value: function changeStatus(status) {
      cov_2oyp5jgfy3.f[3]++;
      cov_2oyp5jgfy3.s[43]++;
      this.setState({
        status: status
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_2oyp5jgfy3.f[4]++;

      var _ref2 = (cov_2oyp5jgfy3.s[44]++, this.props),
          data = _ref2.data,
          className = _ref2.className,
          popoverClassName = _ref2.popoverClassName,
          contentClassName = _ref2.contentClassName,
          dataId = _ref2.dataId,
          trigger = _ref2.trigger,
          compressed = _ref2.compressed,
          cls = _ref2.cls,
          showNum = _ref2.showNum;

      var _ref3 = (cov_2oyp5jgfy3.s[45]++, this.state),
          status = _ref3.status;

      cov_2oyp5jgfy3.s[46]++;

      if ((cov_2oyp5jgfy3.b[10][0]++, showNum < 0) || (cov_2oyp5jgfy3.b[10][1]++, showNum >= data.length)) {
        cov_2oyp5jgfy3.b[9][0]++;
        cov_2oyp5jgfy3.s[47]++;
        return (
          /*#__PURE__*/
          React.createElement(React.Fragment, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 109,
              columnNumber: 9
            }
          }, data,
          /*#__PURE__*/
          React.createElement("a", {
            key: "hidden",
            className: className,
            style: {
              position: 'absolute',
              zIndex: -100,
              userSelect: 'none',
              msUserSelect: 'none',
              contain: 'layout'
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 112,
              columnNumber: 11
            }
          },
          /*#__PURE__*/
          React.createElement("span", {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 123,
              columnNumber: 13
            }
          }, "+")))
        );
      } else {
        cov_2oyp5jgfy3.b[9][1]++;
      }

      var before = (cov_2oyp5jgfy3.s[48]++, new Array(showNum).fill(undefined).map(function (_item, index) {
        cov_2oyp5jgfy3.f[5]++;
        cov_2oyp5jgfy3.s[49]++;
        return data[index];
      }));
      var after = (cov_2oyp5jgfy3.s[50]++, new Array(data.length - showNum).fill(undefined).map(function (_item, index) {
        cov_2oyp5jgfy3.f[6]++;
        cov_2oyp5jgfy3.s[51]++;
        return data[showNum + index];
      }));
      var itemsLength = (cov_2oyp5jgfy3.s[52]++, after.length);
      cov_2oyp5jgfy3.s[53]++;
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 133,
            columnNumber: 7
          }
        }, before,
        /*#__PURE__*/
        React.createElement("a", {
          tabIndex: -1,
          key: "more",
          className: classnames(className, (cov_2oyp5jgfy3.b[11][0]++, cls) && (cov_2oyp5jgfy3.b[11][1]++, status) && (cov_2oyp5jgfy3.b[11][2]++, cls('item-more'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 135,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 136,
            columnNumber: 11
          }
        }, "+".concat(itemsLength)),
        /*#__PURE__*/
        React.createElement(Popover, {
          showArrow: false,
          trigger: trigger,
          visible: status,
          onVisibleChange: this.changeStatus,
          className: popoverClassName,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 137,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: contentClassName,
          "data-id": dataId,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 13
          }
        }, compressed === 'no-repeat' ? (cov_2oyp5jgfy3.b[12][0]++, null) : (cov_2oyp5jgfy3.b[12][1]++, before), after))))
      );
    }
  }]);

  return More;
}(Component);

More.defaultProps = DefaultValue;
export default More;